var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { store } from "@irati/store/index";
import defaultTenant from "@irati/identity/helpers/defaultTenant";
import graph from "@irati/utils/services/graph";
import { toString as loginQuery } from "./queries/adminLogin";
import { toString as ssoLoginQuery } from "./queries/ssoAdminLogin";
import loginErrorHandler from "../services/errors/loginErrorHandler";
import AuthActions from "../store/actions/AuthActions";
import defaultUser from "../helpers/defaultUser";
import { defaultFlags } from "../helpers/featureFlags";
import tokens from "../services/tokens";
import { getAllApps } from "../services/apps";
var InternalLogin = /** @class */ (function () {
    function InternalLogin() {
    }
    InternalLogin.prototype.login = function (uuid, password) {
        var variables = {
            uuid: uuid,
            password: password
        };
        var options = {
            useErrorHandler: false,
            unAuth: true
        };
        return graph({ query: loginQuery, variables: variables }, options)
            .then(function (response) {
            var _a = response.adminLogin, accessToken = _a.accessToken, user = _a.user;
            tokens.set({ accessToken: accessToken }, true).then(function () {
                var auth = store.getState().auth;
                var apps = getAllApps(__assign(__assign({}, auth), { user: user, accessToken: accessToken }));
                store.dispatch(AuthActions.LoginAction({
                    apps: apps,
                    featureFlags: defaultFlags(),
                    rememberMe: true,
                    user: __assign(__assign({}, defaultUser), user),
                    userTenant: defaultTenant
                }));
            });
            return response.adminLogin;
        })
            .catch(loginErrorHandler);
    };
    InternalLogin.prototype.internalSSOLogin = function (googleUser) {
        var variables = {
            googleAccessToken: googleUser.getAuthResponse().id_token
        };
        var options = {
            useErrorHandler: false,
            unAuth: true
        };
        return graph({ query: ssoLoginQuery, variables: variables }, options)
            .then(function (response) {
            var _a = response.ssoAdminLogin, accessToken = _a.accessToken, user = _a.user;
            tokens.set({ accessToken: accessToken }, true).then(function () {
                var auth = store.getState().auth;
                var apps = getAllApps(__assign(__assign({}, auth), { accessToken: accessToken }));
                store.dispatch(AuthActions.LoginAction({
                    apps: apps,
                    featureFlags: defaultFlags(),
                    rememberMe: true,
                    user: __assign(__assign({}, defaultUser), user),
                    userTenant: defaultTenant
                }));
            });
            return response.data;
        })
            .catch(loginErrorHandler);
    };
    return InternalLogin;
}());
var service = new InternalLogin();
export var internalLogin = service.login;
export var internalSSOLogin = service.internalSSOLogin;
export default service;
